import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./index.scss"
import 'animate.css';
import "./swiper.css";

const ua = navigator.userAgent
const isWechat = /MicroMessenger/i.test(ua) && !/wxwork/i.test(ua)
const isEnterpriseWechat = /wxwork/i.test(ua) && /MicroMessenger/i.test(ua)

Vue.config.productionTip = false
import "./utils/rem.js"

import moment from "moment"
Vue.prototype.$moment = moment

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import url from "@/utils/url"
Vue.prototype.$url = url
import Footer from "@/components/Footer"
import Header from "@/components/Header"
import Pagination from "@/components/Pagination"
import { msg } from './utils/utils'
Vue.component('Footer',Footer)
Vue.component('Header',Header)
Vue.component('Pagination',Pagination)
Vue.prototype.msg = msg

import {webRecordLog,wxSign,qySign} from "@/api/news"


router.beforeEach( (to, from, next) => {
  let shareObj={
    title: document.title, 
    desc:document.querySelector('meta[name="description"]').getAttribute('content'),
    link: window.location.href, // 当前页面链接
    imgUrl: 'https://www.chinacamel.com/share.png', // 分享缩略图
  }

  let query={
    name:'visit'
  }
  try {
    webRecordLog(query)
    if(isWechat){
       wxSign(to.path).then(config=>{ 
        wx.config({
            debug: false,   // 调试模式
            appId: config.appId,
            timestamp: config.timestamp,
            nonceStr: config.nonceStr,
            signature: config.signature,
            jsApiList: [    // 需使用的API列表
              'updateAppMessageShareData',
              'updateTimelineShareData'
            ]
        });
        
        wx.ready(() => {
          wx.updateAppMessageShareData(shareObj);
        
          // 分享到朋友圈
          wx.updateTimelineShareData(shareObj);
          
        })
        wx.error(err => {
          console.error("微信SDK错误:", err);
        });
      })
    }
    if(isEnterpriseWechat){
      qySign(to.path).then(config=>{ 
         function getConfigSignature() {
            return { 
              timestamp:config.timestamp,
              nonceStr:config.nonceStr,
              signature:config.signature,
             }
          }
        ww.register({
          corpId: config.appId, 
          getConfigSignature,
          jsApiList: ['onMenuShareAppMessage','onMenuShareWechat','onMenuShareTimeline'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
          ww.onMenuShareAppMessage(shareObj);
          ww.onMenuShareTimeline(shareObj);
          ww.onMenuShareWechat(shareObj);
      })
    }
    
  } catch (error) {

    
  }
  
  next()
 })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
